// Componente principal da página de redefinição de senha
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import PasswordOperation from '../PasswordOperation/PasswordOperation';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const rawToken = searchParams.get('token');

  // O token pode conter + que foi convertido para espaço pelo navegador
  // Vamos reconstruir o token original substituindo espaços por +
  const decodedToken = rawToken ? rawToken.replace(/ /g, '+') : null;

  if (!email || !decodedToken) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>Parâmetros Inválidos</h2>
        <p>O link de redefinição de senha é inválido. Verifique se o link está completo.</p>
      </div>
    );
  }

  return <PasswordOperation params={{ type: 'reset', email, token: decodedToken }} />;
};

export default ResetPassword;